import "./Parallax.css";
export default function Parallax() {
  return (
    <>
      <section className="parallax-section mt-lg-0 mt-4">
        <div className="container-fluid">
          <div className="row">
            <div className="parallax-content my-lg-0 my-5">
              <h2>Best Diamond Testing and Certification Services in India </h2>
              <p className="text-white text-center mt-lg-0 mt-3">
                {" "}
                We offer reliable diamond certification services in India, using
                advanced tools to ensure each diamond meets strict quality and
                authenticity standards. <br /> Our certifications guarantee
                transparency, accuracy, and complete buyer confidence.{" "}
              </p>
            </div>
          </div>
        </div>
      </section>
    </>
  );
}
